var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vc-date-picker',_vm._g(_vm._b({attrs:{"mode":"date","is-expanded":"","title-position":"left","trim-weeks":"","min-date":_vm.startDate,"max-date":_vm.endDate,"model-config":_vm.modelConfig,"select-attribute":_vm.selectAttribute}},'vc-date-picker',{ ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }